export default __webpack_public_path__ + "static/media/error.d46ade7c.svg";